module.exports = __webpack_public_path__ + "static/media/48.d631c225.jpg";